import React, { useState } from "react";
import classnames from "classnames";
import styles from "./LiveDisplaySetup.module.scss";
import HowToSetUp from "./HowToSetUp";
import LetsSeeModal from "../LetsSeeModal";

const vc = styles["vid-container"];

/*
      //Load Modal Function
      function loadModal(clicked, loaded) {
        $(clicked).click(function() {
          $(".lets-see-modal").fadeIn();
          $("#modal-img-container").html(loaded);
          $("html").addClass("modal-open");
        });
      }

      // Modal content
      $(document).ready(function() {
        loadModal(
          ".vid-live-display-preview-img",
          '<video controls autoplay><source src="img/a_Engage-Your-Guests.mp4" type="video/mp4">Your browser does not support the video tag.</video>'
        );
        loadModal(
          ".vid-live-display-4-tips-img",
          '<video controls autoplay><source src="img/a_vid_LiveDisplay4Tips2Success.mp4" type="video/mp4">Your browser does not support the video tag.</video>'
        );
        loadModal(
          ".vid-live-display-equipment-needed-img",
          '<video controls autoplay><source src="img/a_vid_LiveDisplayEquipmentNeeded.mp4" type="video/mp4">Your browser does not support the video tag.</video>'
        );
        // loadModal(
        //   ".vid-live-display-go-full-screen-img",
        //   '<video controls autoplay><source src="img/a_vid_LiveDisplayGoFullScreen.mp4" type="video/mp4">Your browser does not support the video tag.</video>'
        // );
      });

      //empty modal
      $(".close-modal").click(function() {
        $(".lets-see-modal").fadeOut();
        $("#modal-img-container").empty();
        $("html").removeClass("modal-open");
      });
*/

const LiveDisplaySetup: React.FC = () => {
    const [video, setVideo] = useState("");

    return (
        <>
        <div className={classnames("lp-container live-display-setup", styles["live-display-setup"])}>
          <h1 className="lph1">Live Photo Stream Setup</h1>

          <p>
            Setting up Live Photo Stream is easy and creates a super-fun experience
            for your guests.
          </p>

          <div className={classnames("content-container", styles["content-container"])}>
            <div className={classnames("vid-content-container", styles["vid-content-container"])}>
              <div onClick={() => setVideo("img/a_Engage-Your-Guests.mp4") } className={classnames("vid-container vid-live-display-preview-img", vc)} >
                <div className="vid-thumb-container">
                  <img src="img/a_vid-thumb_engage_guests.jpg" />
                  <img className="play-overlay" src="img/vid-thumb-play-overlay.png" />
                </div>
                <p>Live Photo Stream Preview</p>
              </div>

              <div onClick={() => setVideo("img/a_vid_LiveDisplay4Tips2Success.mp4") } className={classnames("vid-container vid-live-display-4-tips-img", vc)}>
                <div className="vid-thumb-container">
                  <img src="img/vid-thumb-live-4-tips.jpg" />
                  <img className="play-overlay" src="img/vid-thumb-play-overlay.png" />
                </div>
                <p>Live Photo Stream 4 Tips</p>
              </div>
              <div onClick={() => setVideo("img/a_vid_LiveDisplayEquipmentNeeded.mp4") } className={classnames("vid-container vid-live-display-equipment-needed-img", vc)}>
                <div className="vid-thumb-container">
                  <img src="img/vid-thumb-live-equip-needed.jpg" />
                  <img className="play-overlay" src="img/vid-thumb-play-overlay.png" />
                </div>
                <p>Live Photo Stream Equipment Needed</p>
              </div>
            </div>
          </div>

          <h4>Let's get started</h4>
          <p>
            First, it's a good idea to see how Live Photo Stream works. To do this,
            take out your laptop (not on your phone), log into your TacBoard account
            and click the "Live" button. You should then see a version of your
            gallery that scrolls automatically and displays your gallery's phone
            number at the top. If you don't already have photos in your gallery,
            text a few to the phone number on the screen so you can see them pop
            onto your screen. Don't worry, you can delete these test photos at any
            time.
          </p>

          <p>
            Now that you've seen your Live Photo Stream in action, let's set it up.
          </p>

          <section id="what-you-need" className="live-setup">
            <h2>What You'll Need</h2>
            <div className="splits">
              <div className="third">
                <div className="feature-icon">
                  <img src="img/live-setup-tv-projector.jpg" />
                </div>
                <h4>TV / Projector &amp; HDMI Cable</h4>
                <p>If you don't have a TV, projector or HDMI cable ask your DJ.</p>
              </div>
              <div className="third">
                <div className="feature-icon">
                  <img src="img/live-setup-laptop-browser.jpg" />
                </div>
                <h4>Laptop with Modern Browser</h4>
                <p>Make sure you have a modern browser like Chrome or Safari.</p>
              </div>
              <div className="third">
                <div className="feature-icon">
                  <img src="img/live-setup-wifi.jpg" />
                </div>
                <h4>Wi-Fi in Venue</h4>
                <p>Confirm adequate Wi-Fi will be provided by your DJ or venue.</p>
              </div>
            </div>
          </section>

			<HowToSetUp />

          <section id="tips-for-success">
            <h4>Tips For Success</h4>
            <ol>
              <li>
                <span>** Test out the Live Photo Stream</span> feature prior to
                event to ensure you’re comfortable using it and have the proper
                equipment.<span>**</span>
              </li>
              <li>
                Use a modern browser like Google Chrome or Microsoft Edge. Avoid
                Internet Explorer if possible!
              </li>
              <li>
                Close all or most of the other programs or browser tabs you have
                open on your computer.
              </li>
              <li>Confirm adequate Wi-Fi will be provided by your DJ or venue.</li>
              <li>
                Open your browser full-screen once you have started the Live Photo
                Stream.
                <p>
                  <strong>Using Chrome on Windows:</strong> Click F11 to enter
                  full-screen then click F11 again to exit.
                </p>
                <p>
                  <strong>Using Chrome On Mac:</strong> Click the green circle in
                  the top-left of Chrome, then to remove the tool bar, while holding
                  both the "command" and "control" keys press the "F" key. Reverese
                  these steps to exit full-screen.
                </p>
              </li>
              <li>
                Make sure your browser zoom is set to 100%. If it is not, it will not infinitely scroll in a continuous loop and will stop at the bottom after one time. Follow the directions below to adjust your zoom. 
                <p className="answer">
                  <strong>On Windows:</strong> You can adjust the page zoom in Google Chrome by pressing the associated hot keys for your operating system. To adjust the page zoom with the keyboard in Windows, press and hold the "Ctrl" key, and then press the "-" (zoom out) or "+" (zoom in) keys on the keyboard.
                </p>
                <p>
                  <strong>On Mac:</strong> To adjust the page zoom with the keyboard on a Mac system, press and hold the "Command" key and then press the "-" or "+" keys on the keyboard. Press and hold the "Ctrl" (Windows) or "Command" key then press "0" to return the zoom to its default value.</p>
                  <p>

             <strong>NOTE: </strong> If your Live Photo Stream continues to stop at the bottom of the page and your screen is at 100% please try 110%. There is a few screen sizes which require the zoom to be at 110%.
                  </p>
              </li>
            </ol>
          </section>
        </div>
        <LetsSeeModal display={video ? "flex" : "none"} close={() => setVideo("") }>
            {video && (
                <video disableRemotePlayback controls autoPlay>
                    <source src={video} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            )}
        </LetsSeeModal>
        </>
    );
};

export default LiveDisplaySetup;
